module.exports = __webpack_public_path__ + "img/phoxWiki.65d05d8b.png";